import { jsx } from "react/jsx-runtime";
import { JobStreetLogo } from "./styles/JobStreet/JobStreet.mjs";
import { JobsDbLogo } from "./styles/JobsDb/JobsDb.mjs";
import { SeekAnzLogo } from "./styles/SeekAnz/SeekAnz.mjs";
const Logo = ({ brand, variant, size }) => {
  switch (brand) {
    case "seek":
      return /* @__PURE__ */ jsx(SeekAnzLogo, { variant, size });
    case "jobstreet":
      return /* @__PURE__ */ jsx(JobStreetLogo, { variant, size });
    case "jobsdb":
      return /* @__PURE__ */ jsx(JobsDbLogo, { variant, size });
    default:
      throw new Error("No brand provided to Logo");
  }
};
export {
  Logo
};
